import { createFileRoute } from '@tanstack/react-router';

import ChatNewPage from '@/screens/chat/chat/new/page';

export const Route = createFileRoute('/_app/_chat/chat/new')({
  component: ChatNewPage,
});
